import ApiRequest from '@/plugins/axios'

export default {
  /*
  async get () {
    return await ApiRequest.get('user')
  },
  */
  update (data) {
    return ApiRequest.put('user/', data)
      .then((response) => {
        return response
      }, (error) => {
        throw error
      })
  },
  updateLayerSettings (data) {
    return ApiRequest.put('user/layersettings', data)
      .then((response) => {
        return response.status
      }, (error) => {
        throw error
      })
  }
}
